module.exports = __webpack_public_path__ + "static/media/Bluelab Guardian Monitor Inline Wi-Fi.31fab3aa.webp";